import { createStore } from 'vuex'
import UQRCode from 'uqrcodejs';
export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    generateQRCode(context, { url, canvasId }) {
      // 获取uQRCode实例
      var qr = new UQRCode();
      qr.setOptions({
        data: url, // 指定二维码对应内容
        size: 150, // 指定要生成的二维码大小
        margin: 5,
        correctLevel: 'H',
        pixelShape: 'square', // 默认是 square，不支持 star
        dotScale: 0.4, // 模块缩放比例（0.1 ~ 1.0），越小越“细”，中间留白多
      });

      // 调用制作二维码方法
      qr.make();
      // 获取canvas元素
      var canvas = document.getElementById(canvasId);
      // 获取canvas上下文
      var canvasContext = canvas.getContext("2d");
      // 设置uQRCode实例的canvas上下文
      qr.canvasContext = canvasContext;
      // 调用绘制方法将二维码图案绘制到canvas上
      qr.drawCanvas();
    },
    // code(url, document) {
    //   // 获取uQRCode实例
    //   var qr = new UQRCode();
    //   qr.setOptions({
    //     data: url, // 指定二维码对应内容
    //     size: 150, // 指定要生成的二维码大小
    //     margin: 5,
    //     correctLevel: 'H',
    //     pixelShape: 'square', // 默认是 square，不支持 star
    //     dotScale: 0.4, // 模块缩放比例（0.1 ~ 1.0），越小越“细”，中间留白多
    //   });

    //   // 调用制作二维码方法
    //   qr.make();
    //   // 获取canvas元素
    //   var canvas = document.getElementById(document);
    //   // 获取canvas上下文
    //   var canvasContext = canvas.getContext("2d");
    //   // 设置uQRCode实例的canvas上下文
    //   qr.canvasContext = canvasContext;
    //   // 调用绘制方法将二维码图案绘制到canvas上
    //   qr.drawCanvas();
    // }
  },
  modules: {
  }
})
